import Config from '../config';
import View from './view';





export default View.extend( {
    serialize() {
        return {
            locale: Config.locale(),
        };
    },
} );


// WEBPACK FOOTER //
// ./src/js/view/common.left-nav.js